import React from 'react';
import injectSheet from 'react-jss';
import styleSheet from './styles';
import Header from 'Components/header';
import useHeapTrack from '../../hooks/useHeapTrack';

interface Props {
  formTitle: string;
  formSubTitle: string;
  logo: string;
  onContinueClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  classes?: any;
}

const AppilyAuthWelcome = ({
  formTitle,
  formSubTitle,
  logo,
  onContinueClick,
  classes,
}: Props) => {
  useHeapTrack('appily_auth_form_viewed');

  return (
    <div className={classes.container}>
      <Header
        fieldIDs={[]}
        formTitle={formTitle}
        formSubTitle={formSubTitle}
        logo={logo}
        appilyAuth={true}
      />
      <div className={classes.appilyContainer}>
        <div className={classes.flexContainer}>
          <div className={classes.textContainer}>
            <div className={classes.headingContainer}>
              <img
                className={classes.stars}
                src="images/personalization_stars.svg"
              />
              <h2 className={classes.header}>
                See what matters most on campus.
              </h2>
            </div>
            <p className={classes.subHeader}>
              Personalize this tour by signing in or create your free profile
              with Appily College Search.
            </p>
          </div>
          <button onClick={onContinueClick} className={classes.appilyButton}>
            Continue with Appily
            <img className={classes.arrow} src="images/UI/right_arrow.svg" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default injectSheet(styleSheet)(AppilyAuthWelcome);
